<template>
  <nav v-if="totalPages > 1"
       class="packages-overview-results-pagination"
  >

    <Button v-show="!isFirstPage"
            icon="@/assets/images/icons/chevron-left.svg"
            class="packages-overview-results-pagination__button"
            @click="toPage(page - 1)"
            />

    <button v-show="showFirstPage"
            :class="[
              'packages-overview-results-pagination__text',
              'packages-overview-results-pagination__text--link',
            ]"
            @click="toPage(1)"
    >
      1
    </button>

    <button v-show="showFirstPage"
            class="packages-overview-results-pagination__text"
    >
      ...
    </button>

    <button v-show="isLastPage && totalPages >= 3"
            :class="[
              'packages-overview-results-pagination__text',
              'packages-overview-results-pagination__text--link',
              'packages-overview-results-pagination__text--previous-page',
            ]"
            @click="toPage(page - 2)"
    >
      {{ page - 2 }}
    </button>

    <button v-show="!isFirstPage"
            :class="[
              'packages-overview-results-pagination__text',
              'packages-overview-results-pagination__text--link',
              'packages-overview-results-pagination__text--previous-page',
            ]"
            @click="toPage(page - 1)"
    >
      {{ page - 1 }}
    </button>

    <button class="packages-overview-results-pagination__text">
      {{ page }}
    </button>

    <button v-show="page < totalPages"
            :class="[
              'packages-overview-results-pagination__text',
              'packages-overview-results-pagination__text--link',
            ]"
            @click="toPage(page + 1)"
    >
      {{ page + 1 }}
    </button>

    <button v-show="isFirstPage && totalPages >= 3"
            :class="[
              'packages-overview-results-pagination__text',
              'packages-overview-results-pagination__text--link',
              'packages-overview-results-pagination__text--next-page',
            ]"
            @click="toPage(3)"
    >
      3
    </button>

    <button v-show="showLastPage"
            class="packages-overview-results-pagination__text"
    >
      ...
    </button>

    <button v-show="showLastPage"
            :class="[
              'packages-overview-results-pagination__text',
              'packages-overview-results-pagination__text--link',
            ]"
            @click="toPage(totalPages)"
    >
      {{ totalPages }}
    </button>

    <Button v-show="!isLastPage"
            icon="@/assets/images/icons/chevron-right.svg"
            iconPosition="right"
            class="packages-overview-results-pagination__button"
            @click="toPage(page + 1)"
    >
      Volgende
    </Button>

  </nav>
</template>

<script>
import Button from '@/components/UI/Button.vue';
import { SEARCH_PARAMS_PAGE } from '@/constants';

export default {
  name: 'ResultsPagination',

  components: {
    Button,
  },

  props: {
    amount: {
      type: Number,
    },
    amountPerPage: {
      type: Number,
      required: true,
    },
    page: {
      type: Number,
    },
  },

  computed: {
    isFirstPage() {
      return this.page <= 1;
    },

    isLastPage() {
      return this.page >= this.totalPages;
    },

    showFirstPage() {
      return this.page >= 3;
    },

    showLastPage() {
      return (
        (this.totalPages - this.page) >= 2
        && this.totalPages > 3
      );
    },

    totalPages() {
      return Math.ceil(this.amount / this.amountPerPage);
    },
  },

  watch: {
    page: {
      handler(value) {
        if (
          value > this.totalPages
          && this.totalPages > 0
        ) {
          this.toPage(this.totalPages);
        }
      },
    },
  },

  created() {
    this.updatePageFromUrl();
  },

  methods: {
    toPage(page) {
      this.$emit('update:page', page);
    },

    updatePageFromUrl() {
      const url = new URL(window.location.href);
      const { searchParams } = url;
      const page = searchParams.get(SEARCH_PARAMS_PAGE);

      this.$emit('update:page', page !== null ? parseInt(page, 10) : 1);
      this.$emit('setPageLoaded', true);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../assets/css/helpers/mixins/breakpoints';

  .packages-overview-results-pagination {
    --padding-horizontal: var(--spacing-m);

    @include laptop-and-larger {
      --padding-horizontal: 0;
    }

    display: flex;
    justify-content: flex-end;
    padding: var(--spacing-l) var(--padding-horizontal) 0;

    &__button {

      &:first-child {
        margin-right: calc(var(--spacing-m) / 2);
      }

      &:last-child {
        margin-left: calc(var(--spacing-m) / 2);
      }

      :deep(.button-sec__icon) {
        @include mobile-only {
          margin: 0;
        }
      }

      :deep(.button-sec__text) {
        @include mobile-only {
          display: none;
        }
      }
    }

    &__text {
      background-color: transparent;
      padding: 0 calc(var(--spacing-m) / 2);
      outline: none;
      color: black;
      cursor: default;

      @include mobile-only {
        font-size: 14px;
      }

      &--link {
        color: var(--color-secondary);
        cursor: pointer;
      }

      &--previous-page,
      &--next-page {

        @include mobile-only {
          display: none;
        }
      }
    }
  }
</style>
